import React from "react";
import { Box, Typography, Link, IconButton, Tooltip } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import DeleteIcon from "@mui/icons-material/Delete";

export default function NotificationTile({
  title,
  message,
  senderName,
  date,
  isRead,
  theme,
  onViewFullOrder,
  onReadOrder,
  onDelete,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "16px",
        marginBottom: "12px",
        backgroundColor: isRead ? theme.palette.grey.light : "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flex: 1,
            alignItems: "flex-start",
          }}
        >
          {!isRead && (
            <CircleIcon
              sx={{ color: "#2e7d32", marginTop: "8px", marginRight: "8px" }}
              fontSize="inherit"
            />
          )}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", marginBottom: "2px" }}
            >
              {title}
            </Typography>
            {senderName && (
              <Typography
                variant="body2"
                sx={{
                  color: "#1976d2",
                  fontWeight: "bold",
                  marginBottom: "8px",
                }}
              >
                Triggered by: {senderName}
              </Typography>
            )}
          </Box>
        </Box>
        <Typography
          variant="body2"
          sx={{ color: "#757575", marginBottom: "8px" }}
        >
          {message}
        </Typography>
        <Typography variant="caption" sx={{ color: "#9e9e9e" }}>
          {date}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Link
          component="button"
          variant="body2"
          onClick={onViewFullOrder}
          sx={{
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: "17px",
            textDecoration: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px 16px",
            backgroundColor: "#1976d2",
            borderRadius: "4px",
            "&:hover": {
              textDecoration: "underline",
            },
            marginLeft: "16px",
          }}
        >
          View Order
        </Link>
        {!isRead && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "bold",
              justifyContent: "center",
              padding: "8px 16px",
              backgroundColor: "#1976d2",
              color: "#ffffff",
              borderRadius: "4px",
              marginLeft: "16px",
              cursor: "pointer",
            }}
            onClick={onReadOrder}
          >
            Mark as Read
          </Box>
        )}
        <Tooltip title="Delete notification">
          <IconButton
            onClick={onDelete}
            sx={{
              color: "error.main",
              marginLeft: "8px",
              backgroundColor: "rgba(211, 47, 47, 0.1)",
              "&:hover": {
                backgroundColor: "rgba(211, 47, 47, 0.2)",
              },
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}
